import { MapColoring, MapColoringType } from "../../map/models/MapColoring";

export namespace DashboardTypes {
  export enum ItemType {
    MiniMap = "MiniMap",
    PieChartMapColoring = "PieChartMapColoring",
    PieChartFullScore = "PieChartFullScore",
    TableTreatmentSuggestionCounter = "TableTreatmentSuggestionCounter",
    TableDistancePerAttributeValue = "TableDistancePerAttributeValue",
  }

  export interface Item {
    type: ItemType;
    name: string | null;
    colSpan: number | null;
  }

  export interface PieChartMapColoring extends Item {
    type: ItemType.PieChartMapColoring;
    coloring: MapColoring;
  }

  export interface CreateDashboardRequest {
    surveyId: string;
    name: string;
    items: DashboardTypes.Item[];
  }

  export interface UpdateDashboardRequest {
    name: string;
    items: DashboardTypes.Item[];
  }

  export interface Dashboard {
    id: string;
    surveyId: string;
    name: string;
    items: DashboardTypes.Item[];
    createdAt: string;
    createdById: string;
  }

  export const getDefaultItemByType = (type: ItemType) => {
    const baseItem: DashboardTypes.Item = {
      type,
      name: null,
      colSpan: null,
    };
    switch (type) {
      case ItemType.PieChartMapColoring:
        return {
          ...baseItem,
          coloring: {
            type: MapColoringType.Score,
            scoreKey: "global",
          },
        } as DashboardTypes.PieChartMapColoring;
      default:
        return baseItem;
    }
  };
}
